var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHideIcon = function SvgHideIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.116 8.06c.439.413.809.813 1.086 1.128.192.223.298.512.298.812s-.106.59-.298.812c-1.214 1.37-3.977 4.036-7.202 4.036h-.462M6.382 13.794a14.5 14.5 0 0 1-3.584-2.982A1.25 1.25 0 0 1 2.5 10c0-.3.106-.59.298-.812C4.012 7.818 6.775 5.15 10 5.15a7.3 7.3 0 0 1 3.618 1.055M16.358 3.333 3.642 16.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.37 11.709a2.48 2.48 0 0 1-.682-1.71c0-.642.244-1.259.677-1.713A2.26 2.26 0 0 1 10 7.576a2.26 2.26 0 0 1 1.63.715"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.667 8.137A2.5 2.5 0 0 0 7.5 10c0 .74.322 1.209.833 1.667M12.012 11.212a2.37 2.37 0 0 1-.856.885"
  })));
};
export default SvgHideIcon;